<template>
    <div class="stock-indicator" v-if="!short && product.availability && product.availability.code !== 'out_of_stock'">
        <div>
            <ProductTotalAvailability :product="product"/>
        </div>
        <div>
            <small v-html="getText()"/>
        </div>
    </div>
</template>

<script setup>
const ProductTotalAvailability = defineAsyncComponent(() => import("~/components/Product/ProductTotalAvailability.vue"));

const props = defineProps({
    product: Object,
    short: Boolean
});

const getText = () => {
    if (props.short) {
        return props.product.availability.short_text || '';
    }

    return props.product.availability.text;
};
</script>
